import { getUrlFromLink } from "./getUrlFromLink";

export { getUrlFromLink };
